import { render, staticRenderFns } from "./SimpleModal.vue?vue&type=template&id=4c18d24f&scoped=true&"
import script from "./SimpleModal.vue?vue&type=script&lang=js&"
export * from "./SimpleModal.vue?vue&type=script&lang=js&"
import style0 from "./SimpleModal.vue?vue&type=style&index=0&id=4c18d24f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c18d24f",
  null
  
)

export default component.exports